import { useQuery } from "@tanstack/react-query";
import { HiverAxios, sendExceptionToSentry } from "h-commons";
import { useSelector } from "react-redux";
import {
  currentUserEmailIdSelector,
  currentUserIdSelector,
} from "../selectors";

export const CONVERSATION_THREAD_ID_QUERY_KEY =
  "CONVERSATION_THREAD_ID_QUERY_KEY";

const fetchThreadIdApi = async ({ gmailunitId, userId, email }) => {
  return new Promise((resolve, reject) => {
    HiverAxios({
      url: "/gx/ext/fetchMessageId",
      type: "GET",
      params: {
        gmail_unit_id: gmailunitId,
        userid: userId,
        email,
      },
      callback: (response) => {
        const { data, status } = response;
        if (status === 200) {
          resolve({ success: true, data });
        } else {
          reject({ success: false });
        }
      },
      onfail: (error) => {
        sendExceptionToSentry(error);
        reject({ success: false });
      },
    });
  });
};

export const useGetThreadId = ({ gmailunitId, isEnabled }) => {
  const email = useSelector(currentUserEmailIdSelector);
  const userId = useSelector(currentUserIdSelector);
  const enabled = !!email && !!userId && isEnabled;
  return useQuery({
    queryKey: [CONVERSATION_THREAD_ID_QUERY_KEY, gmailunitId, userId, email],
    queryFn: () => fetchThreadIdApi({ gmailunitId, userId, email }),
    enabled,
    staleTime: Infinity,
  });
};
